const mark = (name) => {
	performance.mark(name);
};
const getMarks = () => {
	let timeOrigin = performance.timeOrigin;
	if (typeof timeOrigin !== 'number') {
		timeOrigin = performance.timing.navigationStart || performance.timing.redirectStart || performance.timing.fetchStart;
	}
	const result = [{ name: 'code/timeOrigin', startTime: Math.round(timeOrigin) }];
	for (const entry of performance.getEntriesByType('mark')) {
		result.push({
			name: entry.name,
			startTime: Math.round(timeOrigin + entry.startTime)
		});
	}
	return result;
};
export { getMarks, mark };
